<div
  [ngClass]="{
    none: state() === ProgressionStateTypeEnum.None,
    current: state() === ProgressionStateTypeEnum.Current,
  }"
  class="line"></div>
@if (state() === ProgressionStateTypeEnum.Current) {
  <div class="arrow-tip"></div>
}
